// mutations
const RESTAURANT_CATEGORIES_REQUESTS_ALL = (state, restaurantCategories) => {
  if (restaurantCategories.code === 1) {
    state.restaurantCategories = restaurantCategories.data
    state.status = 'success'
  } else {
    alert(restaurantCategories.message)
    state.status = 'error'
  }
}
const RESTAURANT_CATEGORIES_FORM = (state, restaurantCategories) => {
  if (restaurantCategories.code === 1) {
    state.restaurantCategories = restaurantCategories.data
    state.status = 'success'
  } else {
    alert(restaurantCategories.message)
    state.status = 'error'
  }
}
const RESTAURANT_CATEGORIES_CREATE = (state, restaurantCategories) => {
  if (restaurantCategories.code === 1) {
    state.restaurantCategories = restaurantCategories.data
    state.status = 'success'
    alert(restaurantCategories.message)
  } else {
    alert(restaurantCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_CATEGORIES_DELETE = (state, restaurantCategories) => {
  if (restaurantCategories.code === 1) {
    state.restaurantCategories = restaurantCategories.data
    state.status = 'success'
    alert(restaurantCategories.message)
  } else {
    alert(restaurantCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_CATEGORIES_SHOW = (state, restaurantCategories) => {
  if (restaurantCategories.code === 1) {
    state.restaurantCategories = restaurantCategories.data
    state.status = 'success'
  } else {
    alert(restaurantCategories.message)
    state.status = 'error'
  }
}

const RESTAURANT_CATEGORIES_UPDATE = (state, restaurantCategories) => {
  if (restaurantCategories.code === 1) {
    state.restaurantCategories = restaurantCategories.data
    state.status = 'success'
    alert(restaurantCategories.message)
  } else {
    alert(restaurantCategories.message)
    state.status = 'error'
  }
}

export default {
  RESTAURANT_CATEGORIES_REQUESTS_ALL,
  RESTAURANT_CATEGORIES_FORM,
  RESTAURANT_CATEGORIES_CREATE,
  RESTAURANT_CATEGORIES_DELETE,
  RESTAURANT_CATEGORIES_SHOW,
  RESTAURANT_CATEGORIES_UPDATE
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/categories/mutations.js